
<script>
    import ModalService from "../services/ModalService";

    export let disableLink = false;

    function learnMore() {
       ModalService.about();
    }
</script>

<style>

    div {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        justify-content: space-between;
        margin-top: 12px
    }

    p {
        max-width: 900px;
        padding: 0 12px 0 12px;
    }

</style>

<div>
    <p>
        <slot/>
    </p>
    {#if !disableLink}
        <a class="link" on:click={learnMore}>Learn More ></a>
    {/if}
</div>
